const LoginProvider = {
  GOOGLE: 'Google',
  APPLE: 'Apple',
  XERO: 'Xero',
};

export { LoginProvider };
